/* eslint-disable*/

import PropTypes from 'prop-types';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  localSupplyScoreConvert,
  publicTransportScoreConvert,
  cultureScoreConvert,
  wohnlageScoreConvert,
} from '../../../../utils/helpers/lagescoresValuesConvert';

import Bars from '../bars';

const DesktopScoreItem = ({
  item,
  type,
  height,
  width,
  viva,
  newScore,
  selectedLayer,
}) => {
  return (
    <div className="cards__rating" style={viva === 2 ? { width: '300px' } : {}}>
      <OverlayTrigger
        placement={viva === 2 ? 'top' : 'right'}
        overlay={
          <Tooltip id={viva === 2 ? 'viva-tooltip' : 'tooltip-right'}>
            {viva !== 2 && (
              <img
                src={`/assets/img/cardIcons/${type}.svg`}
                height={height}
                width={width}
                style={{ position: 'absolute', left: '10px' }}
                alt=""
              />
            )}
            {type === 'wohnlage' &&
              newScore === 0 &&
              'Für diese Immobilie konnte der Score leider nicht berechnet werden.'}
            {type === 'wohnlage' && newScore > 0 && (
              <p
                style={{
                  fontSize: '13px',
                  fontFamily: 'Roboto',
                  lineHeight: '16px',
                }}
              >
                Als Community entwickeln wir für die Bundesrepublik Deutschland
                flächendeckend eine Systematik zur Bewertung von Wohnlagen
                inklusive der flächendeckenden vor Ort Bewertung von
                Wohnquartieren.
                <br />
                <br />
                Initiator und Moderator ist Zukunfts-, Markt- und Preisforschung
                | IIB Institut
              </p>
            )}
            {type === 'opnv' && newScore > 0.04 && (
              <p
                style={{
                  fontSize: '13px',
                  fontFamily: 'Roboto',
                  lineHeight: '16px',
                }}
              >
                Wie gut ist die Anbindung an den öffentlichen Nahverkehr? Der
                Score berücksichtigt z. B. die Nähe zur nächsten Bus- und
                Bahnhaltestelle und wie viele Personen sie wie schnell damit
                erreichen können.
                <br />
                <br />
                Initiator und Moderator ist Zukunfts-, Markt- und Preisforschung
                | IIB Institut
              </p>
            )}
            {type === 'Nahversorgung' && newScore > 0.04 && (
              <p
                style={{
                  fontSize: '13px',
                  fontFamily: 'Roboto',
                  lineHeight: '16px',
                }}
              >
                Habe ich vor Ort, was ich brauche? Dieser Score bildet ab, wie
                verfügbar Versorgungsangebote des alltäglichen Bedarfs sind.
                Enthalten sind z. B. Supermärkte, Drogerien, Kindergärten,
                Schulen, Krankenhäuser und Apotheken
                <br />
                <br />
                Initiator und Moderator ist Zukunfts-, Markt- und Preisforschung
                | IIB Institut
              </p>
            )}
            {type === 'kultur' && newScore > 0.04 && (
              <p
                style={{
                  fontSize: '13px',
                  fontFamily: 'Roboto',
                  lineHeight: '16px',
                }}
              >
                Ist hier etwas los? Der Score bildet kulturelle Dienstleistungen
                zur Freizeit- und Abendgestaltung ab, an denen sich Menschen
                versammeln können. Enthalten sind z. B. Restaurants, Cafes,
                Biergärten, Museen, Theater, Kinos, Nachtclubs und Bars.
                <br />
                <br />
                Initiator und Moderator ist Zukunfts-, Markt- und Preisforschung
                | IIB Institut
              </p>
            )}
            {(type === 'kultur' ||
              type === 'Nahversorgung' ||
              type === 'opnv') &&
              newScore <= 0.04 &&
              'Für diese Immobilie konnte der Score leider nicht berechnet werden'}
          </Tooltip>
        }
      >
        <button
          type="button"
          style={{
            border: 'none',
            backgroundColor: 'transparent',
            display: 'flex',
            padding: 0,
          }}
        >
          <div className="label-image__container">
            <img
              src={`/assets/img/cardIcons/${type}.svg`}
              height={height}
              width={width}
              alt=""
            />
          </div>
        </button>
      </OverlayTrigger>
      <div
        className="rating__icon-container-label"
        style={{
          textTransform: 'capitalize',
          marginRight: '7%',
          fontSize: '11px',
        }}
      >
        {type === 'opnv' ? 'ÖPNV' : type}
      </div>
      {type === 'wohnlage' && (
        <Bars
          viva={2}
          newScore={wohnlageScoreConvert(item.wohnlage)}
          layerName="Wohnlage"
          fadeColor={selectedLayer === 'Wohnlage' ? false : true}
        />
      )}
      {type === ('opnv' || 'ÖPNV') && (
        <Bars
          viva={2}
          newScore={publicTransportScoreConvert(item.publicTransport)}
          layerName="ÖPNV"
          fadeColor={selectedLayer === 'ÖPNV' ? false : true}
        />
      )}
      {type === ('kultur' || 'Kultur') && (
        <Bars
          viva={2}
          newScore={cultureScoreConvert(item.culture)}
          layerName="Kultur"
          fadeColor={selectedLayer === 'Kultur' ? false : true}
        />
      )}
      {type === ('Nahversorgung' || 'Nahversorgung') && (
        <Bars
          viva={2}
          newScore={localSupplyScoreConvert(item.localSupply)}
          layerName="Nahversorgung"
          fadeColor={selectedLayer === 'Nahversorgung' ? false : true}
        />
      )}
    </div>
  );
};

DesktopScoreItem.propTypes = {
  viva: PropTypes.number.isRequired,
  newScore: PropTypes.number,
  type: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
};

DesktopScoreItem.defaultProps = {
  newScore: 3,
};

export default DesktopScoreItem;
